import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import AcademyToSoftware from '../../../containers/AcademyToSoftware/AcademyToSoftware';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeaturedSoftwareCoursesSubtitle = ({
  isEnrolledOrPaid,
  selectedTab
}) => {
  if (isEnrolledOrPaid) {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `learningCenter.featuredSoftwareCourses.learnPaidAndEnrolledCoursesLessons`
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.featuredSoftwareCourses.everyAccountToolsLink",
      options: {
        hubspotToolsLink: /*#__PURE__*/_jsx(AcademyToSoftware, {
          selectedField: selectedTab,
          use: "inline-link"
        })
      }
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `learningCenter.featuredSoftwareCourses.learnGenericCoursesLessons`
    })]
  });
};
export default FeaturedSoftwareCoursesSubtitle;